import React from 'react';
import renderHTML from 'react-render-html';

const Header = ({ title, description }) => {
	return (
		<header className="header-callout row">
			<div className="col">
				<h1>{ renderHTML(title) }</h1>
				{ description !== undefined ? <p>{ renderHTML(description) }</p> : null }
			</div>
		</header>
	);
};

export default Header;


// WEBPACK FOOTER //
// ./src/pages/common/Header.js